var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrder = function SvgOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1543_45108)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M22.5 0H.5v22h22z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#303030",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.917 2.75H5.083c-.506 0-.917.37-.917.825v14.85c0 .456.41.825.917.825h12.834c.506 0 .916-.37.916-.825V3.575c0-.456-.41-.825-.916-.825Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.125 8.25h5.5M10.125 13.75h5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303030",
    fillRule: "evenodd",
    d: "M7.375 9.167a.917.917 0 1 0 0-1.834.917.917 0 0 0 0 1.834M7.375 14.667a.917.917 0 1 0 0-1.834.917.917 0 0 0 0 1.834",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1543_45108"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h22v22H.5z"
  })))));
};
export default SvgOrder;